import styled from 'styled-components';
import { espacamento } from '../../styles/constants/sizes';

export const Footer = styled.div`
  @media screen and (max-width: 800px) {
    background-color: #f2f2f2;
    color: #828282;
    font-family: BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    border-top: 1px solid #ddd;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
  }
`;

export const Assinatura = styled.div`
  display: none;

  @media screen and (max-width: 800px) {
    padding: ${espacamento.extraPequeno}px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;

    p {
    padding: ${espacamento.pequeno}px;
    line-height: 1.8;
    display: inline-block;
    font-size: .7em;
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 0;
    }

    img {
      max-width: 100%;
      vertical-align: middle;
      height: 15px;
      margin-left: -4px;
      margin-bottom: 1px;
    }
  }
`;
